import type { IconAsset } from '../Icon.types';

const code = (
  <g data-name='Group 9607' id='Group_9607' transform='translate(-80.77 -844)'>
    <rect
      data-name='Rectangle 25186'
      fill='none'
      height='16'
      id='Rectangle_25186'
      transform='translate(80.77 844)'
      width='16'
    />
    <g id='iconfinder_calendar_465050' transform='translate(48.469 844.9)'>
      <rect
        data-name='Rectangle 3055'
        fill='currentColor'
        height='1.783'
        id='Rectangle_3055'
        transform='translate(39.491 6.808)'
        width='1.783'
      />
      <rect
        data-name='Rectangle 3056'
        fill='currentColor'
        height='1.783'
        id='Rectangle_3056'
        transform='translate(42.287 6.808)'
        width='1.783'
      />
      <rect
        data-name='Rectangle 3057'
        fill='currentColor'
        height='1.783'
        id='Rectangle_3057'
        transform='translate(36.698 9.519)'
        width='1.783'
      />
      <rect
        data-name='Rectangle 3058'
        fill='currentColor'
        height='1.783'
        id='Rectangle_3058'
        transform='translate(39.491 9.519)'
        width='1.783'
      />
      <rect
        data-name='Rectangle 3059'
        fill='currentColor'
        height='1.783'
        id='Rectangle_3059'
        transform='translate(42.287 9.519)'
        width='1.783'
      />
      <path
        d='M127.5,3.494h0a.8.8,0,0,1-.8-.8V.9a.8.8,0,0,1,.8-.8h0a.8.8,0,0,1,.8.8V2.7A.8.8,0,0,1,127.5,3.494Z'
        data-name='Path 3824'
        fill='currentColor'
        id='Path_3824'
        transform='translate(-89.865)'
      />
      <path
        d='M45.176,61.9H44.27v1.089a1.214,1.214,0,0,1-1.2,1.221H42.75a1.214,1.214,0,0,1-1.2-1.221V61.9h-2.48v1.089a1.214,1.214,0,0,1-1.2,1.221h-.318a1.214,1.214,0,0,1-1.2-1.221V61.9h-.694A1.367,1.367,0,0,0,34.3,63.272v9.6a1.367,1.367,0,0,0,1.353,1.372h9.526a1.367,1.367,0,0,0,1.353-1.372v-9.6A1.371,1.371,0,0,0,45.176,61.9Zm-.23,9.679a.85.85,0,0,1-.84.853h-7.38a.85.85,0,0,1-.84-.853V66.74a.879.879,0,0,1,.84-.886h7.38a.879.879,0,0,1,.84.886Z'
        data-name='Path 3825'
        fill='currentColor'
        id='Path_3825'
        transform='translate(0 -60.104)'
      />
      <path
        d='M320,3.494h0a.8.8,0,0,1-.8-.8V.9a.8.8,0,0,1,.8-.8h0a.8.8,0,0,1,.8.8V2.7A.8.8,0,0,1,320,3.494Z'
        data-name='Path 3826'
        fill='currentColor'
        id='Path_3826'
        transform='translate(-277.084)'
      />
    </g>
  </g>
);

export const calendar: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
